import { render, staticRenderFns } from "./PasswordResetVerification.vue?vue&type=template&id=1d246f7e&scoped=true"
import script from "./PasswordResetVerification.vue?vue&type=script&lang=js"
export * from "./PasswordResetVerification.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetVerification.vue?vue&type=style&index=0&id=1d246f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d246f7e",
  null
  
)

export default component.exports